import React, {FC} from 'react';
import {useSelector} from 'react-redux';
import {useLocalizer} from '@/common/services/localizer';
import {usePageMetaSetter} from '@/common/services/headTagger';
import {selectDomainConfig} from '@/app/store/config/selectors';
import styles from './NotFound.css';

export const NotFound: FC = () => {
	const t = useLocalizer();

	const domainName = useSelector(selectDomainConfig)!.domainName.toUpperCase();

	// Set SEO tags
	usePageMetaSetter({
		title: t('notFoundSEO.title', {domainName}),
	});

	return (
		<div className={styles.root}>
			<main className={styles.main}>
				<h1 className={styles.title}>{t('notFoundTitle')}</h1>
				<p className={styles.description}>{t('notFoundInfo.0')}</p>
				<p className={styles.description}>{t('notFoundInfo.1')}</p>
				<p className={styles.description}>{t('notFoundInfo.2')}</p>
			</main>
		</div>
	);
};

NotFound.displayName = 'NotFound';
